import { render, staticRenderFns } from "./ListOfScientificWorks.vue?vue&type=template&id=07ea93f2&"
import script from "./ListOfScientificWorks.vue?vue&type=script&lang=js&"
export * from "./ListOfScientificWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports